export default __webpack_public_path__ + "static/media/elastic-container-registry.0978cc77.svg";